import _ from 'lodash';
import React, { useContext, useEffect } from 'react';
import { Menu } from 'semantic-ui-react';
import { SettingParentContext } from '../../../cnr/contexts/SettingParentContext';
import { SettingsAreaContext } from '../../../cnr/contexts/SettingsAreaContext';
import SettingsMenuProvider, { SettingsMenuContext } from '../../../cnr/contexts/SettingsMenuContext';
import { gEnums } from '../../../enums/globalEnums';
import { iconColorTypes } from '../../../enums/settingsIconTypes';
import Wrapper from '../../../wrappers/Wrapper';
import SettingsSearch from '../../SettingsSearch';
import SettingsAreaGroupMenu from './SettingsAreaGroupMenu';
import SettingsAreaGroupsMenu from './SettingsAreaGroupsMenu';
import SettingsAreaMenuBottom from './SettingsAreaMenuBottom';
import SettingsAreaMenuHeader from './SettingsAreaMenuHeader';
import { currentHelpers } from '../../../redirection/current';
import { SquaresWrapper } from 'global/wrappers/SquaresWrapper';

// const firstItems = ['client', 'event', 'quickLinks']

// IMPORTANT: Settings - SettingsAreaMenu
/** The side settings menu for the desktop view 
 @description This is ONLY a list of menu items. The swiper takes effect after the first click
*/

// IMPORTANT: Settings - SettingsAreaMenu
/**
 * This is the SICE settings menu for the desktop view. It's menu items are ONLY the major groups
 * The swiper (`ViewSettings`) takes effect after the first click.
 * the menus are divided into 4 parts
 * SettingsAreaMenuHeader
 * SettingsAreaGroupsMenu - these are the main settings
 * SettingsAreaMenuBottom
 * SettingsAreaGroupMenu
 * 
 */
const SettingsAreaMenu = () => {

  // settingsParentContext
  const settingsParentContext = useContext(SettingParentContext)
  const { states, fns } = settingsParentContext ?? {}
  const { paps_state, page_state, currentSettings_state } = states ?? {}
  const { appUser_fns, navigation_fns } = fns ?? {}
  const { appArea, view, viewKey, otherView, pathViews, settingsDocName, trueView } = paps_state ?? {}

  // pageViewContext  
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { status, settingsSourceType, settingsOriginalSourceType } = _.get(page_state, 'pageSettings', {});
  const { sideMenu } = aps_global ?? {}

  // settingsAreaContext
  const settingsAreaContext = useContext(SettingsAreaContext);
  const { settingsArea_state } = settingsAreaContext ?? {}
  const {
    isGlobal,
    isSolo,
    menuAuthGroups,
    settingsGroupsByGroupType,
    settingsOptions,
    settingsOriginType,
  } = settingsArea_state ?? {}

  // settingsMenuContext
  const settingsMenuContext = useContext(SettingsMenuContext)
  const { settingsMenu_state, settingsMenu_handlers, settingsMenu_fns } = settingsMenuContext ?? {}
  const {
    activeAll,
    activeMenus,
    allowGroupMenuSort, // set by handleAllowGroupMenuSort 
    selectedGroupItem,
    showSearch,
  } = settingsMenu_state ?? {}

  const { useCollapsibleMenus, useDarkMode, allowSearch } = settingsOptions ?? {}

  const isEmpty = otherView ? false : false
  let globalName = _.startCase(appArea)

  const topCaption = isGlobal ? globalName + ' Settings' : 'Page Settings'
  const subCaption = isGlobal ? settingsDocName : trueView
  const subTimeStamp = status && status.lastUpdate
  const subDisplayName = status && status.displayName

  const _viewPermissionType = appUser_fns.validate_settingsMenuAuth()

  let lsName = 'activeMenus_'
  lsName += isGlobal ? 'global' : 'view'
  let initActive = currentHelpers.storageItem_get(lsName)

  if (!initActive) {
    initActive = { app: false, data: false, content: true, permissions: false, styling: true, view: true }
  } else {
    initActive = JSON.parse(initActive)
  }

  // run when selectedGroupItem has a value
  useEffect(() => {
    if (selectedGroupItem) {
      settingsMenu_fns.handleGroupItemClick(selectedGroupItem)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedGroupItem])

  // return <Segment inverted>{'isGlobal'}{':'}{isGlobal.toString()}{'/'}{appArea_sa}</Segment>

  const handleUpdateAll = () => settingsMenu_handlers.handleUpdateAll()
  const handleAllowGroupMenuSort = () => settingsMenu_handlers.handleAllowGroupMenuSort()

  const rightMenuItemProps = {
    icon: activeAll ? 'expand' : 'window maximize outline',
    handleUpdateAll,
    handleAllowGroupMenuSort,
    show: useCollapsibleMenus,
    allowGroupMenuSort
  }

  /**
   * 
   * @returns SettingsAreaMenuHeader
   */
  const settingsAreaMenu_header = () => {
    const x = { sideMenu, isGlobal, iconLeft: isGlobal ? 'settings' : 'setting', iconLeftColor: iconColorTypes.menuItem, topCaption, subCaption, subTimeStamp, subDisplayName, settingsSourceType, settingsOriginalSourceType, rightMenuItemProps }
    return <SettingsAreaMenuHeader {...x} />
  }

  /**
   * 
   * @returns SettingsAreaMenuBottom
   */
  const settingsAreaMenu_bottom = () => {
    const mbProps = { activeAll, isGlobal, isSolo, pathViews, navigation_fns, handleUpdateAll, useCollapsibleMenus, useDarkMode, view, viewKey, _viewPermissionType }
    return <SettingsAreaMenuBottom mbProps={mbProps} />
  }

  /**
   * 
   * @returns SettingsAreaGroupMenu
   */
  // const settingsAreaMenu_footer = () => {
  //   const group = { key: 'search', iconColor: 'green', allowed: true, groupItems: {} }
  //   const _grpSettings = { caption: 'Search', icon: 'search' }
  //   addGroupItem(group, 'search', 'search')
  //   const _menuGroup = <SettingsAreaGroupMenu group={group} grpSettings={_grpSettings} inverse={true} />
  //   if (Object.keys(group.groupItems).length > 0) {
  //     return <Menu borderless inverted={useDarkMode} vertical fluid className={'menu-groups msmi three adm'}>{_menuGroup}</Menu>
  //   }
  // }

  const addGroupItem = (grp, key, goto) => {
    grp.groupItems[key] = { ui: { caption: _.startCase(key) }, gotoKey: goto }
  }

  /**
   * THIS IS THE MAIN MENU
   * @returns a `Menu` element with `MenuItemsGroups` inside
   */
  const settingsAreaMenu_groups = () => <SettingsAreaGroupsMenu />

  /**
   * 
   * @param {string} wcn 
   * @param {string} ccn 
   * @returns a `Wrapper` with `Menus`
   */
  const wrapper = (wcn, ccn) => <Wrapper
    header={!fromApp ? settingsAreaMenu_header() : null}
    // content={<SquaresWrapper isGlobal={isGlobal} />}
    content={menuAuthGroups && settingsAreaMenu_groups()}
    // footer={allowSearch ? settingsAreaMenu_footer() : settingsAreaMenu_bottom()}
    // footer2={allowSearch && settingsAreaMenu_bottom()}
    css={{ container: wcn, content: ccn }}
  />

  const menuContent = (wcn, ccn) => activeMenus && wrapper(wcn, ccn)

  const fromApp = settingsOriginType === gEnums.settingsOriginTypes.app

  let scn = 'padd0'
  scn += ' settings-dark-mode'

  if (isEmpty) {
    return (
      <div className={scn + ' empty'} >???</div>
    )
  } else {
    let wcn = 'setz sm'
    if (useDarkMode) { wcn += ' settings-dark-mode' }
    if (isSolo) { wcn += ' app' }
    const ccn = 'ct-vs'
    return showSearch ? <SettingsSearch settingsGroupsByGroupType={settingsGroupsByGroupType} /> : menuContent(wcn, ccn)
  }
}

export default SettingsAreaMenu

/**
 * depricated
 * @returns 
 */
export const SettingsAreaMenuWithProvider = (props) => {
  return <SettingsMenuProvider>
    <SettingsAreaMenu {...props} />
  </SettingsMenuProvider>
}